<template>
  <div class="login">
    <h1>德义物联设备登记平台和追踪平台</h1>
    <el-card>
        <h2>欢迎登录</h2>
        <div class="line"><span></span></div>
        <div class="location"><el-image style="width: 20%"
      :src="logoUrl"
      fit="contain"></el-image></div>
        <el-form ref="form" :model="form" :rules="rules" label-width="0px">
          <el-form-item prop="userName">
            <el-input v-model="form.userName" prefix-icon="el-icon-user" placeholder="手机号/人员工号" @blur="inputBlur"></el-input>
          </el-form-item>
          <el-form-item prop="password">
              <el-input v-model="form.password" prefix-icon="el-icon-lock" placeholder="******" type="password" @blur="inputBlur"></el-input>
          </el-form-item>
          <el-form-item class="submit">
              <el-button type="primary" @click="login">进入</el-button>
          </el-form-item>
        </el-form>
    </el-card>
  </div>
</template>

<script>
import {login} from "/api/dengLu"
import { mapMutations, mapGetters } from "vuex";
import store from "/store/index";
import { SET_USER } from "/store/mutation-types";
import RkCd from "/components/ruKou_caiDan";
import md5 from "js-md5"
import {outMenuEnum} from "/util/outMenuEnum";
export default {
  name: 'DengLu',
  components: {
    RkCd
  },
  data () {
    return {
        logoUrl: require('/assets/images/icon.png'),
        form:{
          userName:"",
          password:""
        },
        rules: {
          userName: [
            { required: true, message: '请输入手机号或工号', trigger: 'blur' },
            { min:1, max: 11, message: '请输入正确的手机号或工号', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ]
        }
    }
  },
  mounted(){
    if(store.getters.isLogin){
        this.handleOpenGotoPanel();
    }
  },
  methods:{
    ...mapMutations([SET_USER]),
    login(){
      this.$refs['form'].validate((valid) => {
          if (valid) {
            var params = {
                userName:this.form.userName,
                password:md5(this.form.password)
            }
            login(params).then(data => {
              this[SET_USER](data);
                this.handleOpenGotoPanel();
            }).catch(error => {
                    console.error(error);
                    this.$message({
                    type: 'error',
                    message: error
                    });
                })
                .finally(() => {
                });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    handleOpenGotoPanel(){
        outMenuEnum.outMenu(this);
    },
    inputBlur() {
      //window.scroll(0, 0);
      window.scrollTo({
        top:0,
        left:0,
        behavior: "smooth"
        //支持参数 smooth(平滑滚动),instant(瞬间滚动)
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-card h2 {
    color: #fff;
    text-align: center;
    padding: 1em 0;
    font-size: 1.6em;
    font-weight: 300;
}

.el-card {
    width: 28%;
    margin: 0 auto;
    text-align: center;
    background: #323542;
    padding: 4em;
}

.location {
    padding: 1em 0;
}

.line {
    position: relative;
}

.line span {
    position: absolute;
    top: 10%;
    left: 39%;
    background: #5b5c61;
    height: 1px;
    width: 20%;
}

.el-form {
    padding: 0% 1%;
}

/*-----*/
.location img {
    margin: 2em 0;
}

.submit {
    margin: 1em 0;
}

.el-button {
    font-size: 20px;
    font-weight: 300;
    color: #fff;
    cursor: pointer;
    outline: none;
    padding: 17px 15px;
    width: 100%;
    border: 3px solid #0791fa;
    background: #0791fa;
    border-radius: 0.3em;
    -o-border-radius: 0.3em;
    -webkit-border-radius: 0.3em;
    -moz-border-radius: 0.3em;
    /* margin: 5px; */
}

button:hover {
    background: none;
    border: 3px solid #0791fa;
    color: #0791fa;

}

/*---------------*/
.copy-right {
    padding: 3em 1em;
}

.copy-right p {
    color: #fff;
    font-size: 1em;
    font-weight: 400;
    margin: 0 auto;
    text-align: center;
}

.copy-right p a {
    color: #323542;
}

.copy-right p a:hover {
    text-decoration: underline;
}

/*-----start-responsive-design------*/
@media (max-width:1440px) {
    .el-card {
        width: 30%;
    }

}

@media (max-width:1366px) {
    .el-card {
        width: 34%;
    }

    .line span {
        position: absolute;
        top: 10%;
        left: 39%;
        background: #5b5c61;
        height: 1px;
        width: 20%;
    }

    body h1 {
        font-size: 2.6em;
    }

}

@media (max-width:1280px) {
    .el-card {
        width: 37%;
    }

}

@media (max-width:1024px) {
    .el-card {
        width: 47%;
    }

}

@media (max-width:768px) {
    body h1 {
        font-size: 2.4em;
    }

    .location img {
        margin: 2em 0;
        width: 59%;
    }

    .el-card h2 {
        padding: 0.8em 0;
        font-size: 1.6em;
    }

    .line span {
        top: 10%;
        left: 39%;
        height: 1px;
        width: 20%;
    }

    .el-card {
        width: 63%;
    }

    .copy-right {
        padding: 1em 1em;
    }

}

@media (max-width:640px) {
    body h1 {
        font-size: 2.1em;
    }

    .el-card {
        width: 69%;
    }
}

@media (max-width:480px) {

    .el-card {
        width: 90%;
        padding: 2em 1em 1em 1em;
    }

    .copy-right p {
        font-size: 0.9em;
    }


    .el-form {
        width: 82%;
        margin: 0 auto;
    }
}

@media (max-width:320px) {
    .el-card {
        width: 87%;
        padding: 2em 1em 1em 1em;
    }

    body h1 {
        font-size: 1.5em;
    }

    .copy-right p {
        font-size: 0.85em;
        line-height: 1.7em;
    }

    .el-card h2 {
        padding: 0.5em 0;
        font-size: 1.2em;
    }

    .line span {
        top: 10%;
        left: 35%;
        height: 1px;
        width: 29%;
    }

    .submit {
        margin: 0.5em 0;
    }

    .el-card button {
        font-size: 18px;
        padding: 11px 11px;
    }

    .el-form {
        width: 87%;
        margin: 0 auto;
    }

}
</style>



// WEBPACK FOOTER //
// src/page/dengLu.vue